<template>
  <div id="app" class="full-height">
    <!--  <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOutUp"
      mode="out-in"
    > -->
    <router-view v-if="showApp" />
    <!-- </transition> -->
  </div>
</template>

<script>
import { getSystemDic } from './api/register.js';
import { localDataUser, localDataPermission } from '@iebdc/utils/local-data';
export default {
  name: 'app',
  data() {
    return {
      showApp: false,
    };
  },
  created() {
    // 获取区域权限
    // 看用户是否登录
    const user = localDataUser.get();
    if (user && user.userId) {
      this.$store.dispatch('getPermission', user.userId);
    } else {
      this.$store.dispatch('getPermission');
    }
    // 初始化字典值
    getSystemDic();
    let _this = this;
    let wait = setInterval(function () {
      //确保有值
      if (localDataPermission.get()) {
        //清除定时器
        _this.showApp = true;
        clearInterval(wait);
      }
    }, 50);
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Microsoft YaHei';
  min-width: 1200px;
}
</style>
